// @flow
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { AppBar, Tab, Tabs } from '@mui/material';
import { navigate } from '../../state/navigation/navigation';
import Routes from '../../routing/routes';
import useTabNavigation from '../hooks/useTabNavigation';

export default function NavBar() {
    const { pathname } = useLocation();

    const isAuthenticated = useSelector(state => state.authentication.isAuthenticated);
    const tabs = useTabNavigation();
    const [value, setValue] = useState(tabs.findIndex(pathObj => pathname?.includes(pathObj.path)));

    useEffect(() => {
        const setActiveTab = () => {
            const index = tabs.findIndex(pathObj => pathname?.includes(pathObj.path));
            return setValue(index);
        };

        setActiveTab();
    }, [tabs, pathname]);

    const hiddenPaths = [
        Routes.LOGIN.path,
        Routes.CREATE_ACCOUNT.path,
        Routes.CREATE_ACCOUNT_CONVERT.path,
        Routes.FORGOT_PASSWORD.path,
        Routes.ACCEPT_ASSISTANT_COACH.path
    ];
    
    const hideNav = hiddenPaths.indexOf(pathname) > -1;

    if (hideNav || !isAuthenticated) {
        return null;
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const generateTabs = () =>
        tabs.map((tab, _index) => (
            <Tab
                key={`${tab.name}`}
                href={tab.path}
                component="a"
                onClick={event => {
                    event.preventDefault();
                    navigate(tab.path);
                }}
                label={tab.name}
            />
        ));

    return (
        <div data-testid="nav-bar" className="nav-bar">
            <AppBar position="static" color="default">
                <Tabs value={value} onChange={handleChange}>
                    {generateTabs()}
                </Tabs>
            </AppBar>
        </div>
    );
}
